var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 841.9 595.3",
    style: {
      enableBackground: "new 0 0 841.9 595.3"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;stroke:#1D1D1B;stroke-width:23;stroke-miterlimit:10;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M540.9,302.7c-12.6-12.6-33.1-12.6-45.7,0s-12.6,33.1,0,45.7c25.3,25.3,66.1,25.3,91.4,0 c25.3-25.3,25.3-66.1,0-91.4c-37.9-37.9-99.2-37.9-137.1,0c-37.9,37.9-37.9,99.2,0,137.1c50.5,50.5,132.3,50.5,182.8,0 c50.5-50.5,50.5-132.3,0-182.8c-63.2-63.2-165.4-63.1-228.5,0c-10.7,10.7-19.6,22.5-26.7,35.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M301,302.1c12.6-12.6,33.1-12.6,45.7,0c12.6,12.6,12.6,33.1,0,45.7c-25.3,25.3-66.1,25.3-91.4,0 c-25.3-25.3-25.3-66.1,0-91.4c37.9-37.9,99.2-37.9,137.1,0c37.9,37.9,37.9,99.2,0,137.1c-50.5,50.5-132.3,50.5-182.8,0 s-50.5-132.3,0-182.8c58-58,148.8-62.7,212.2-14.3"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.ed88515fd0aa634e5de7016a9842acaa.svg";
export { ForwardRef as ReactComponent };